/* eslint-disable @typescript-eslint/no-explicit-any */
// Parser for GABC

import { CstParser } from 'chevrotain';
import {
  CLEF,
  CLEF_FLATTED,
  CLEF_SECONDARY,
  CLEF_SECONDARY_FLATTED,
  H_EPISEMA,
  NOTE_BIVIRGA,
  NOTE_DISTROPHA,
  NOTE_DISTROPHA_AUCTUS_ASCENDENS,
  NOTE_PUNCTUM, NOTE_PUNCTUM_FUSED,
  NOTE_PUNCTUM_INCLINATUM,
  NOTE_PUNCTUM_INCLINATUM_FUSED,
  NOTE_PUNCTUM_INCLINATUM_INITIO_DEBILIS,
  NOTE_PUNCTUM_INITIO_DEBILIS, NOTE_TRISTROPHA,
  NOTE_TRISTROPHA_AUCTUS_ASCENDENS, NOTE_TRIVIRGA,

  PUNCTUM_MORA,

  B_VIRGULA_PAREN_HIGH,
  B_VIRGULA_PAREN,
  B_VIRGULA_HIGH,
  B_VIRGULA,
  B_DIVISIO_MINIMIS_HIGH,
  B_DIVISIO_MINIMIS,
  B_DIVISIO_MINIMA_PAREN_HIGH,
  B_DIVISIO_MINIMA_PAREN,
  B_DIVISIO_MINIMA_HIGH,
  B_DIVISIO_MINIMA,
  B_DIVISIO_MINOR,
  B_DIVISIO_FINALIS,
  B_DIVISIO_MAIOR,
  B_DIVISIO_MAIOR_DOTTED,

  STRING_LITERAL,
  // STRING_LITERAL_VERBATIM,
  // STRING_LITERAL_SPECIAL,
  // STRING_LITERAL_ITALIC,
  // STRING_LITERAL_BOLD,

  TAIL_LIQUIESCENIA,
  TAIL_LIQUIESCENIA_AUCTUS_DESCENDENS,
  TAIL_LIQUIESCENIA_DEMINUTUS,

  S_QUADRATUM,
  S_ORISCUS_UNDETERMINED,
  S_ORISCUS_DESCENDENS,
  S_ORISCUS_ASCENDENS,
  S_ORISCUS_SCAPUS_UNDETERMINED,
  S_ORISCUS_SCAPUS_DESCENDENS,
  S_ORISCUS_SCAPUS_ASCENDENS,
  S_QUILISMA,
  S_QUILISMA_QUADRATUM,
  S_VIRGA,
  S_VIRGA_REVERSA,
  S_STROPHA,
  S_FLAT,
  S_FLAT_PAREN,
  S_SHARP,
  S_SHARP_PAREN,
  S_NATURAL,
  S_NATURAL_PAREN,
  S_LINEA,
  S_LINEA_PUNCTUM,

  CAVUM,
  S_LINEA_PUNCTUM_CAVUM,

  SP_HALF_SPACE,
  SP_INTERGLYPH_SPACE,
  SP_NEUMATIC_CUT,
  SP_GLYPH_SPACE,
  SP_LARGER_SPACE,
  SP_LARGER_SPACE_NB,
  SP_GLYPH_SPACE_NB,
  SP_ZERO_WIDTH,

  END_OF_LINE,
  END_OF_LINE_FORSES_CUSTOS,
  END_OF_LINE_FORSES_CUSTOS_ON,

  END_OF_LINE_RAGGED,
  END_OF_LINE_RAGGED_CUSTOS,
  END_OF_LINE_RAGGED_CUSTOS_ON,

  V_EPISEMA,
  WHITESPACE_SINGLE,

  NABC_COMPLEX_NEUME_SEPARATOR,
  NABC_HORIZONTAL_SPACING_ADJUSTMENT,
  NABC_GLYPH_MODIFIER,
  NABC_PITCH,

  NABC_BASIC_GLYPH_GALL,
  NABC_BASIC_GLYPH_LAON,


  CUSTOS,
  MANUAL_CUSTOS,
  B_DOMINICAN_BAR,
  NABC_SIGNIFICANT_LETTER_GALL,
  NABC_SUBPUNCTIS_AND_PREPUNCTIS_GALL,
  NABC_SUBPUNCTIS_AND_PREPUNCTIS_LAON,
  NABC_SIGNIFICANT_LETTER_LAON,
  NABC_SIGNIFICANT_LETTER_TIRONIAN_LAON,
  // NABC_ERROR,
  STRING_LITERAL_OPENING_TAG,
  STRING_LITERAL_CLOSING_TAG,
} from '../common/LexerTokens';
import { LexerContext } from '../common/LexerContext';
import { L_PAREN_PUSHING_GABC, L_PAREN_PUSHING_NABC_GALL, L_PAREN_PUSHING_NABC_LAON, R_PAREN_POPPING, WHITESPACE_DELIMETER } from './CompoundedLexer';

export class CompoundedParser extends CstParser {
  private readonly _settings: LexerContext;
  private readonly _pipeElements: any;

  constructor(settings: LexerContext, pipeElements: any) {
    super([
      CLEF,
      CLEF_FLATTED,
      CLEF_SECONDARY,
      CLEF_SECONDARY_FLATTED,
      H_EPISEMA,
      L_PAREN_PUSHING_GABC,
      NOTE_BIVIRGA,
      NOTE_DISTROPHA,
      NOTE_DISTROPHA_AUCTUS_ASCENDENS,
      NOTE_PUNCTUM, NOTE_PUNCTUM_FUSED,
      NOTE_PUNCTUM_INCLINATUM,
      NOTE_PUNCTUM_INCLINATUM_FUSED,
      NOTE_PUNCTUM_INCLINATUM_INITIO_DEBILIS,
      NOTE_PUNCTUM_INITIO_DEBILIS, NOTE_TRISTROPHA,
      NOTE_TRISTROPHA_AUCTUS_ASCENDENS, NOTE_TRIVIRGA,
      PUNCTUM_MORA,
      R_PAREN_POPPING,
      STRING_LITERAL,
      TAIL_LIQUIESCENIA,
      TAIL_LIQUIESCENIA_AUCTUS_DESCENDENS,
      TAIL_LIQUIESCENIA_DEMINUTUS,
      V_EPISEMA,
      WHITESPACE_DELIMETER,
    ], {
      recoveryEnabled: true,
    });

    this._settings = settings;
    this._pipeElements = pipeElements;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const $: any = this;

    $.RULE('score', () => {
      $.AT_LEAST_ONE_SEP({
        SEP: WHITESPACE_DELIMETER,
        DEF: () => $.SUBRULE($.word),
      });
    });

    $.RULE('word', () => {
      $.AT_LEAST_ONE(() => $.SUBRULE($.syllable));
      $.SUBRULE($.lyrics);
    });

    $.RULE('syllable', () => {
      $.SUBRULE($.lyrics);
      if (this._settings.nabcOnlyParser) {
        if (this._settings.nabcMode === 'gall') {
          $.CONSUME(L_PAREN_PUSHING_NABC_GALL);
        } else if (this._settings.nabcMode === 'laon') {
          $.CONSUME(L_PAREN_PUSHING_NABC_LAON);
        }
      } else {
        $.CONSUME(L_PAREN_PUSHING_GABC);
      }
      if (this._settings.nabcOnlyParser) {
        $.AT_LEAST_ONE_SEP({
          SEP: this._pipeElements.NABC_BEGIN_PIPE,
          DEF: () => {
            $.SUBRULE($.nabcOnlySegment);
          },
        });
      } else {
        $.AT_LEAST_ONE_SEP({
          SEP: this._pipeElements.GABC_BEGIN_PIPE,
          DEF: () => {
            $.SUBRULE($.segment);
          },
        });
      }
      $.CONSUME(R_PAREN_POPPING);
    });

    $.RULE('lyrics', () => {
      $.MANY(() => {
        $.OR([
          {
            ALT: () => {
              $.CONSUME(STRING_LITERAL_OPENING_TAG);
              $.SUBRULE($.lyrics);
              $.OPTION(() => $.CONSUME1(STRING_LITERAL_CLOSING_TAG));
            }
          },
          { 
            ALT: () => {
              $.CONSUME(STRING_LITERAL);
              $.OPTION2(() => $.CONSUME2(STRING_LITERAL_CLOSING_TAG));
            } 
          },
          { ALT: () => $.CONSUME(WHITESPACE_SINGLE) },
        ]);
      });
    });

    $.RULE('nabcOnlySegment', () => {
      if (this._settings.nabcMode === 'gall') {
        $.SUBRULE($.nabcGallExpression);
      } else if (this._settings.nabcMode === 'laon') {
        $.SUBRULE($.nabcLaonExpression);
      }
    });

    $.RULE('segment', () => {
      $.OPTION(() => $.SUBRULE($.gabcExpression));
      $.OPTION2(() => $.CONSUME(this._pipeElements.NABC_BEGIN_PIPE));
      if (this._settings.nabcMode === 'gall') {
        $.OPTION3(() => $.SUBRULE($.nabcGallExpression));
      } else if (this._settings.nabcMode === 'laon') {
        $.OPTION3(() => $.SUBRULE($.nabcLaonExpression));
      }
    });

    $.RULE('gabcExpression', () => {
      $.MANY(() => {
        $.OR([
          { ALT: () => $.CONSUME(CLEF) },
          { ALT: () => $.CONSUME(CLEF_FLATTED) },
          { ALT: () => $.CONSUME(CLEF_SECONDARY) },
          { ALT: () => $.CONSUME(CLEF_SECONDARY_FLATTED) },
          { ALT: () => $.CONSUME(NOTE_BIVIRGA) },
          { ALT: () => $.CONSUME(NOTE_TRIVIRGA) },
          { ALT: () => $.CONSUME(NOTE_DISTROPHA) },
          { ALT: () => $.CONSUME(NOTE_DISTROPHA_AUCTUS_ASCENDENS) },
          { ALT: () => $.CONSUME(NOTE_TRISTROPHA) },
          { ALT: () => $.CONSUME(NOTE_TRISTROPHA_AUCTUS_ASCENDENS) },
          { ALT: () => $.CONSUME(NOTE_PUNCTUM) },
          { ALT: () => $.CONSUME(NOTE_PUNCTUM_INITIO_DEBILIS) },
          { ALT: () => $.CONSUME(NOTE_PUNCTUM_FUSED) },
          { ALT: () => $.CONSUME(NOTE_PUNCTUM_INCLINATUM) },
          { ALT: () => $.CONSUME(NOTE_PUNCTUM_INCLINATUM_INITIO_DEBILIS) },
          { ALT: () => $.CONSUME(NOTE_PUNCTUM_INCLINATUM_FUSED) },
          { ALT: () => $.CONSUME(V_EPISEMA) },
          { ALT: () => $.CONSUME(H_EPISEMA) },
          { ALT: () => $.CONSUME(PUNCTUM_MORA) },

          { ALT: () => $.CONSUME(B_VIRGULA_PAREN_HIGH) },
          { ALT: () => $.CONSUME(B_VIRGULA_PAREN) },
          { ALT: () => $.CONSUME(B_VIRGULA_HIGH) },
          { ALT: () => $.CONSUME(B_VIRGULA) },

          { ALT: () => $.CONSUME(B_DIVISIO_MINIMIS_HIGH) },
          { ALT: () => $.CONSUME(B_DIVISIO_MINIMIS) },
          { ALT: () => $.CONSUME(B_DIVISIO_MINIMA_PAREN_HIGH) },
          { ALT: () => $.CONSUME(B_DIVISIO_MINIMA_PAREN) },
          { ALT: () => $.CONSUME(B_DIVISIO_MINIMA_HIGH) },
          { ALT: () => $.CONSUME(B_DIVISIO_MINIMA) },
          { ALT: () => $.CONSUME(B_DIVISIO_MINOR) },
          { ALT: () => $.CONSUME(B_DIVISIO_FINALIS) },
          { ALT: () => $.CONSUME(B_DIVISIO_MAIOR) },
          { ALT: () => $.CONSUME(B_DIVISIO_MAIOR_DOTTED) },
          { ALT: () => $.CONSUME(B_DOMINICAN_BAR) },

          { ALT: () => $.CONSUME(TAIL_LIQUIESCENIA_DEMINUTUS) },
          { ALT: () => $.CONSUME(TAIL_LIQUIESCENIA_AUCTUS_DESCENDENS) },
          { ALT: () => $.CONSUME(TAIL_LIQUIESCENIA) },

          { ALT: () => $.CONSUME(S_QUADRATUM) },
          { ALT: () => $.CONSUME(S_QUILISMA) },
          { ALT: () => $.CONSUME(S_QUILISMA_QUADRATUM) },
          { ALT: () => $.CONSUME(S_STROPHA) },
          { ALT: () => $.CONSUME(S_VIRGA) },
          { ALT: () => $.CONSUME(S_VIRGA_REVERSA) },

          { ALT: () => $.CONSUME(S_ORISCUS_SCAPUS_ASCENDENS) },
          { ALT: () => $.CONSUME(S_ORISCUS_SCAPUS_DESCENDENS) },
          { ALT: () => $.CONSUME(S_ORISCUS_SCAPUS_UNDETERMINED) },

          { ALT: () => $.CONSUME(S_ORISCUS_ASCENDENS) },
          { ALT: () => $.CONSUME(S_ORISCUS_DESCENDENS) },
          { ALT: () => $.CONSUME(S_ORISCUS_UNDETERMINED) },

          { ALT: () => $.CONSUME(S_FLAT) },
          { ALT: () => $.CONSUME(S_FLAT_PAREN) },
          { ALT: () => $.CONSUME(S_SHARP) },
          { ALT: () => $.CONSUME(S_SHARP_PAREN) },
          { ALT: () => $.CONSUME(S_NATURAL) },
          { ALT: () => $.CONSUME(S_NATURAL_PAREN) },

          { ALT: () => $.CONSUME(S_LINEA) },
          { ALT: () => $.CONSUME(S_LINEA_PUNCTUM) },

          { ALT: () => $.CONSUME(CAVUM) },
          { ALT: () => $.CONSUME(S_LINEA_PUNCTUM_CAVUM) },

          { ALT: () => $.CONSUME(SP_HALF_SPACE) },
          { ALT: () => $.CONSUME(SP_INTERGLYPH_SPACE) },
          { ALT: () => $.CONSUME(SP_NEUMATIC_CUT) },
          { ALT: () => $.CONSUME(SP_GLYPH_SPACE) },
          { ALT: () => $.CONSUME(SP_LARGER_SPACE) },
          { ALT: () => $.CONSUME(SP_LARGER_SPACE_NB) },
          { ALT: () => $.CONSUME(SP_GLYPH_SPACE_NB) },
          { ALT: () => $.CONSUME(SP_ZERO_WIDTH) },

          { ALT: () => $.CONSUME(END_OF_LINE) },
          { ALT: () => $.CONSUME(END_OF_LINE_FORSES_CUSTOS) },
          { ALT: () => $.CONSUME(END_OF_LINE_FORSES_CUSTOS_ON) },
          { ALT: () => $.CONSUME(END_OF_LINE_RAGGED) },
          { ALT: () => $.CONSUME(END_OF_LINE_RAGGED_CUSTOS) },
          { ALT: () => $.CONSUME(END_OF_LINE_RAGGED_CUSTOS_ON) },

          { ALT: () => $.CONSUME(CUSTOS) },
          { ALT: () => $.CONSUME(MANUAL_CUSTOS) },

          { ALT: () => $.CONSUME(WHITESPACE_SINGLE) },
        ]);
      });
    });

    $.RULE('nabcGallExpression', () => {
      $.AT_LEAST_ONE(() => {
        $.SUBRULE($.nabcGallNeume);
      });
    });

    $.RULE('nabcGallNeume', () => {
      $.OPTION(() => $.CONSUME(NABC_HORIZONTAL_SPACING_ADJUSTMENT));
      $.SUBRULE($.nabcGallGlyphs),
        $.MANY1(() => {
          $.CONSUME(NABC_SUBPUNCTIS_AND_PREPUNCTIS_GALL);
        });
      $.MANY(() => {
        $.CONSUME(NABC_SIGNIFICANT_LETTER_GALL);
      });
      // $.MANY2(() => $.CONSUME(NABC_ERROR));
    });

    $.RULE('nabcGallGlyphs', () => {
      $.AT_LEAST_ONE_SEP({
        SEP: NABC_COMPLEX_NEUME_SEPARATOR,
        DEF: () => {
          $.SUBRULE($.nabcGallGlyph);
        },
      });
    });

    $.RULE('nabcGallGlyph', () => {
      $.CONSUME(NABC_BASIC_GLYPH_GALL);
      $.OPTION(() => $.CONSUME(NABC_GLYPH_MODIFIER));
      $.OPTION1(() => $.CONSUME(NABC_PITCH));
    });

    $.RULE('nabcLaonExpression', () => {
      $.AT_LEAST_ONE(() => {
        $.SUBRULE($.nabcLaonNeume);
      });
    });

    $.RULE('nabcLaonNeume', () => {
      $.OPTION(() => $.CONSUME(NABC_HORIZONTAL_SPACING_ADJUSTMENT));
      $.SUBRULE($.nabcLaonGlyphs),
        $.MANY1(() => {
          $.CONSUME(NABC_SUBPUNCTIS_AND_PREPUNCTIS_LAON);
        });
      $.MANY(() => {
        $.OR([
          { ALT: () => $.CONSUME(NABC_SIGNIFICANT_LETTER_LAON), },
          { ALT: () => $.CONSUME(NABC_SIGNIFICANT_LETTER_TIRONIAN_LAON), },
        ]);
      });
      // $.OPTION2(() => $.CONSUME(NABC_ERROR));
    });

    $.RULE('nabcLaonGlyphs', () => {
      $.AT_LEAST_ONE_SEP({
        SEP: NABC_COMPLEX_NEUME_SEPARATOR,
        DEF: () => {
          $.SUBRULE($.nabcLaonGlyph);
        },
      });
    });

    $.RULE('nabcLaonGlyph', () => {
      $.CONSUME(NABC_BASIC_GLYPH_LAON);
      $.OPTION(() => $.CONSUME(NABC_GLYPH_MODIFIER));
      $.OPTION1(() => $.CONSUME(NABC_PITCH));
    });

    this.performSelfAnalysis();
  }

  parse() {
    return (this as any).score();
  }
}
